import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formattaCampo",
})
export class PulisciNomeCampoPipe implements PipeTransform {
  transform(value: string): any {
    value = value
      .replace(/[A-Z]/g, (str) => " " + str.toLowerCase())
      .split("/")
      .join(" ");
    //  value = value.replace(/[0-9]/g, (str) => " ");

    /*     value = value.split("/").join(" "); */

    return value.charAt(1).toUpperCase() + value.substr(2).toLowerCase();
  }
}
